import { render, staticRenderFns } from "./lie.vue?vue&type=template&id=f9230508&"
import script from "./lie.component.ts?vue&type=script&lang=ts&"
export * from "./lie.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports